import React, { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { getRollFromMobileNumber } from '../utils/rolemap';
import { PROXYLOGIN, LOGOUT, UPDATE_USER_DETAIL, USER_PROFILE } from '../utils/ApiEndPoint';

const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const storeduser = JSON.parse(localStorage.getItem('user'));
    const storedIsLoggedIn = localStorage.getItem('isLoggedIn');
    return storedIsLoggedIn && storeduser?.token ? JSON.parse(storedIsLoggedIn) : false;
  });
  const [user, setUser] = useState(() => {
    let storedUser = localStorage.getItem('user');
    if (storedUser) {
      storedUser = JSON.parse(storedUser);
      if (storedUser?.selectedRole) {
        return storedUser;
      } else if (storedUser?.lmsRoles) {
        storedUser['selectedRole'] = storedUser?.lmsRoles;
        return storedUser;
      }
    }
  });
  useEffect(() => {
    if (user?.token) {
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', user.token);
      setIsLoggedIn(true);
    } else {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      setIsLoggedIn(false);
    }
  }, [user]);
  useEffect(() => {
    if (isLoggedIn) {
      localStorage.setItem('isLoggedIn', isLoggedIn);
    }
    else {
      localStorage.removeItem('isLoggedIn');
    }
  }, [isLoggedIn]);
  const login = (credentials, callback, otp = null) => {
    if (!credentials || !credentials.password || !credentials.mobile) {
      if (typeof callback === 'function') callback({ status: 'error', message: 'Missing credentials' });
      return;
    }
    const data = new FormData();
    data.append('deviceType', 'web');
    data.append('password', credentials?.password);
    data.append('mobile', credentials?.mobile);
    data.append('otp', otp !== null ? otp : 180698);
    data.append('sessionId', credentials?.sessionId);
    data.append('captchaCode', credentials?.captchaCode);
    apiClient.post(PROXYLOGIN, data)
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.data?.type && response.data?.data?.type === 'internal') {
            console.log("🚀 krishna  ~ response:", response);
            const mobileNumber = response.data?.data?.mobileNumber || '';
            const rolles = response.data?.data?.roles?.length ? response.data?.data?.roles : [{ "roleName": "viewer", "pmfbyRoleId": "viewer", "displayUserType": "NCIP User" }];
            const lmsRoles = getRollFromMobileNumber(mobileNumber);
            const tempUserdata = {
              roles: rolles,
              lmsRoles,
              token: response.data?.token || '',
              email: response.data?.data?.email || '',
              mobileNumber: mobileNumber,
              name: response.data?.data?.name || '',
              hp: response.data?.data?.hashedPassword,
              userId: response.data?.data?._id || '',
              selectedRole: lmsRoles,
              lastLoginAt: response.data?.data?.lastLoginAt || null,
              organisation:response.data?.data?.organisation||'',
              bankName: response.data?.data?.bankName ||'',
              bankType:response.data?.data?.bankType ||'',
              branchCode: response.data?.data?.branchCode || '',
              branchName: response.data?.data?.branchName || '',
              createdAt: response.data?.data?.createdAt,
              district: response.data?.data?.district || '',
              districtCode: response.data?.data?.districtCode || '',
              insuranceCompanyCode: response.data?.data?.insuranceCompanyCode || '',
              insuranceCompanyName: response.data?.data?.insuranceCompanyName || '',
              state: response.data?.data?.state || '',
              stateCode: response.data?.data?.stateCode || '',
              type: response.data?.data?.type,
              updatedAt: response.data?.data?.updatedAt,
            };
            setIsLoggedIn(response.data?.token ? true : false);
            setUser(tempUserdata);
            localStorage.setItem('token', response.data?.token)
            if (typeof callback === 'function') callback({ status: 'success', data: tempUserdata });
          }
          else if(response.data?.data?.type && response.data?.data?.type === 'external'){
            const mobileNumber = response.data?.data?.mobileNumber || '';
            const rolles = [{ "roleName": "viewer", "pmfbyRoleId": "viewer",'displayUserType': 'external' }];
            const lmsRoles = getRollFromMobileNumber(mobileNumber);
            const tempUserdata = {
              roles: rolles,
              lmsRoles,
              token: response.data?.token || '',
              email: response.data?.data?.email || '',
              mobileNumber: mobileNumber,
              name: response.data?.data?.name || '',
              hp: response.data?.data?.hashedPassword,
              userId: response.data?.data?._id || '',
              selectedRole: lmsRoles,
              lastLoginAt: response.data?.data?.lastLoginAt || null,
              organisation:response.data?.data?.organisation||'',
              bankName: response.data?.data?.bankName ||'',
              bankType:response.data?.data?.bankType ||'',
              branchCode: response.data?.data?.branchCode || '',
              branchName: response.data?.data?.branchName || '',
              createdAt: response.data?.data?.createdAt,
              district: response.data?.data?.district || '',
              districtCode: response.data?.data?.districtCode || '',
              insuranceCompanyCode: response.data?.data?.insuranceCompanyCode || '',
              insuranceCompanyName: response.data?.data?.insuranceCompanyName || '',
              state: response.data?.data?.state || '',
              stateCode: response.data?.data?.stateCode || '',
              type: response.data?.data?.type,
              updatedAt: response.data?.data?.updatedAt,
            };
            setIsLoggedIn(response.data?.token ? true : false);
            setUser(tempUserdata);
            localStorage.setItem('token', response.data?.token)
            if (typeof callback === 'function') callback({ status: 'success', data: tempUserdata });
          }else {
            if (typeof callback === 'function') callback({ status: 'error', message: 'Wrong User type. Please check the information and try again.' });
          }
        } else {
          console.log("🚀 krishna  ~ response:", response);
        }
      })
      .catch((err) => {
        const errorMessage = err?.data?.error || 'Login failed';
        if (typeof callback === 'function') callback({ status: 'error', message: errorMessage });
      });
  };

  const logout = async (callback) => {
    const { mobileNumber, hp } = user;
    const data = new FormData();
    data.append('mobile', mobileNumber);
    data.append('password', hp);
    apiClient.post(LOGOUT, data)
      .then((response) => {
        console.log("🚀 krishna  ~ response:", response);
      })
      .catch((err) => {
        console.log("🚀 krishna  ~ err:", err);
      }).finally(() => {
        setIsLoggedIn(false);
        setUser(null);
        localStorage.removeItem('token');
        localStorage.removeItem('isLoggedIn');
        if (typeof callback === 'function') callback();
      });

  };
  const switchUser = (callback) => {
    const userData = user
    if (userData?.selectedRole == 'viewer') {
      userData['selectedRole'] = userData?.lmsRoles;
    } else {
      userData['selectedRole'] = 'viewer';
    }

    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    if (callback) {
      callback();
    }
  };
  const updateUserDetail=(data,callback)=>{
    // console.log("🚀 krishna  ~ data:", data);
    apiClient.put(UPDATE_USER_DETAIL, data)
      .then((response) => {
        // console.log("🚀 krishna  ~ response:", response);
        const tempUserdata = {
              // roles: rolles,
              // lmsRoles,
              // token: response.data?.token || '',
              // email: response.data?.data?.email || '',
              // mobileNumber: mobileNumber,
              // name: response.data?.data?.name || '',
              // hp: response.data?.data?.hashedPassword,
              // userId: response.data?.data?._id || '',
              // selectedRole: lmsRoles,
              // lastLoginAt: response.data?.data?.lastLoginAt || null,
              // organisation:response.data?.data?.organisation||'',
              // bankName: response.data?.data?.bankName ||'',
              // bankType:response.data?.data?.bankType ||'',
              // branchCode: response.data?.data?.branchCode || '',
              // branchName: response.data?.data?.branchName || '',
              // createdAt: response.data?.data?.createdAt,
              // district: response.data?.data?.district || '',
              // districtCode: response.data?.data?.districtCode || '',
              insuranceCompanyCode: data?.insuranceCompanyCode || '',
              insuranceCompanyName: data?.insuranceCompanyName || '',
              // state: response.data?.data?.state || '',
              // stateCode: response.data?.data?.stateCode || '',
              // type: response.data?.data?.type,
              // updatedAt: response.data?.data?.updatedAt,
            };
        setUser((prev) => ({ ...prev,  ...tempUserdata }));
        if(callback){
          callback(true);
        }
      })
      .catch((err) => {
        if(callback){
          callback(false);
        }
        console.log("🚀 krishna  ~ err:", err);
      }).finally(() => {
        
      });
  }
  const refreshUserProfile = (callback) => {
    apiClient.get(USER_PROFILE)
      .then((response) => {
        if (response.status === 200 && response.data?.data) {
          const profile = response.data.data;
          const nextUser = {
            ...user,
            email: profile.email || '',
            mobileNumber: profile.mobileNumber || '',
            name: profile.name || '',
            organisation: profile.organisation || '',
            language: profile.language || '',
            zone: profile.zone || '',
            designation: profile.designation || '',
            gender: profile.gender || '',
            bankName: profile.bankName || '',
            bankType: profile.bankType || '',
            branchCode: profile.branchCode || '',
            branchName: profile.branchName || '',
            district: profile.district || '',
            districtCode: profile.districtCode || '',
            insuranceCompanyCode: profile.insuranceCompanyCode || '',
            insuranceCompanyName: profile.insuranceCompanyName || '',
            state: profile.state || '',
            stateCode: profile.stateCode || '',
            type: profile.type,
            updatedAt: profile.updatedAt,
          };
          setUser(nextUser);
          if (callback) callback(true, nextUser);
        } else if (callback) {
          callback(false);
        }
      })
      .catch(() => {
        if (callback) callback(false);
      });
  };

  return (
    <LoginContext.Provider value={{ isLoggedIn, login, logout, user, switchUser, updateUserDetail, refreshUserProfile }}>
      {children}
    </LoginContext.Provider>
  );
};

export const useLogin = () => useContext(LoginContext);
